import EditLocations from "./EditLocations";
export default EditLocations;
